"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Advantage", {
  enumerable: true,
  get: function get() {
    return _Advantage["default"];
  }
});
Object.defineProperty(exports, "AirportItem", {
  enumerable: true,
  get: function get() {
    return _AirportItem["default"];
  }
});
Object.defineProperty(exports, "BagSelector", {
  enumerable: true,
  get: function get() {
    return _BagSelector["default"];
  }
});
Object.defineProperty(exports, "BookingConfirmation", {
  enumerable: true,
  get: function get() {
    return _BookingConfirmation["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});
Object.defineProperty(exports, "DiscontinuousLine", {
  enumerable: true,
  get: function get() {
    return _DiscontinuousLine["default"];
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});
Object.defineProperty(exports, "Checkmark", {
  enumerable: true,
  get: function get() {
    return _Checkmark["default"];
  }
});
Object.defineProperty(exports, "ColorIcon", {
  enumerable: true,
  get: function get() {
    return _ColorIcon["default"];
  }
});
Object.defineProperty(exports, "Flight", {
  enumerable: true,
  get: function get() {
    return _Flight["default"];
  }
});
Object.defineProperty(exports, "FlightItemStops", {
  enumerable: true,
  get: function get() {
    return _FlightItemStops["default"];
  }
});
Object.defineProperty(exports, "FlightSummary", {
  enumerable: true,
  get: function get() {
    return _FlightSummary["default"];
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _Title["default"];
  }
});
Object.defineProperty(exports, "SubTitle", {
  enumerable: true,
  get: function get() {
    return _SubTitle["default"];
  }
});
Object.defineProperty(exports, "Picture", {
  enumerable: true,
  get: function get() {
    return _Picture["default"];
  }
});
Object.defineProperty(exports, "BobLink", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});
Object.defineProperty(exports, "Legend", {
  enumerable: true,
  get: function get() {
    return _Legend["default"];
  }
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function get() {
    return _Loading["default"];
  }
});
Object.defineProperty(exports, "Map", {
  enumerable: true,
  get: function get() {
    return _Map["default"];
  }
});
Object.defineProperty(exports, "MobileCta", {
  enumerable: true,
  get: function get() {
    return _MobileCta["default"];
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _Notification["default"];
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "Promocode", {
  enumerable: true,
  get: function get() {
    return _Promocode["default"];
  }
});
Object.defineProperty(exports, "RadioButton", {
  enumerable: true,
  get: function get() {
    return _RadioButton["default"];
  }
});
Object.defineProperty(exports, "SlotDaySelector", {
  enumerable: true,
  get: function get() {
    return _SlotDaySelector["default"];
  }
});
Object.defineProperty(exports, "Terminal", {
  enumerable: true,
  get: function get() {
    return _Terminal["default"];
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});
Object.defineProperty(exports, "AltFooter", {
  enumerable: true,
  get: function get() {
    return _AltFooter["default"];
  }
});
Object.defineProperty(exports, "BobInfo", {
  enumerable: true,
  get: function get() {
    return _BobInfo["default"];
  }
});
Object.defineProperty(exports, "Popup", {
  enumerable: true,
  get: function get() {
    return _Popup["default"];
  }
});
Object.defineProperty(exports, "PriceBreakdown", {
  enumerable: true,
  get: function get() {
    return _PriceBreakdown["default"];
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _Tabs["default"];
  }
});
Object.defineProperty(exports, "TimeSlots", {
  enumerable: true,
  get: function get() {
    return _TimeSlots["default"];
  }
});
Object.defineProperty(exports, "TravelWidget", {
  enumerable: true,
  get: function get() {
    return _TravelWidget["default"];
  }
});
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function get() {
    return _Spinner["default"];
  }
});
Object.defineProperty(exports, "ServiceStatus", {
  enumerable: true,
  get: function get() {
    return _ServiceStatus["default"];
  }
});
Object.defineProperty(exports, "Timeline", {
  enumerable: true,
  get: function get() {
    return _Timeline["default"];
  }
});
Object.defineProperty(exports, "ProviderCookie", {
  enumerable: true,
  get: function get() {
    return _index["default"];
  }
});
Object.defineProperty(exports, "ProviderDate", {
  enumerable: true,
  get: function get() {
    return _index2["default"];
  }
});
Object.defineProperty(exports, "ProviderValidate", {
  enumerable: true,
  get: function get() {
    return _index3["default"];
  }
});
Object.defineProperty(exports, "helpers", {
  enumerable: true,
  get: function get() {
    return _helpers.helpers;
  }
});
Object.defineProperty(exports, "font", {
  enumerable: true,
  get: function get() {
    return _widths.font;
  }
});
Object.defineProperty(exports, "widths", {
  enumerable: true,
  get: function get() {
    return _widths.widths;
  }
});
Object.defineProperty(exports, "mediaQueries", {
  enumerable: true,
  get: function get() {
    return _widths.mediaQueries;
  }
});
Object.defineProperty(exports, "imageQueries", {
  enumerable: true,
  get: function get() {
    return _widths.imageQueries;
  }
});
Object.defineProperty(exports, "palette", {
  enumerable: true,
  get: function get() {
    return _palette.palette;
  }
});
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function get() {
    return _normalize.normalize;
  }
});
Object.defineProperty(exports, "COLOR_ICONS", {
  enumerable: true,
  get: function get() {
    return _colorIcons.COLOR_ICONS;
  }
});
Object.defineProperty(exports, "ICONS", {
  enumerable: true,
  get: function get() {
    return _icons.ICONS;
  }
});
Object.defineProperty(exports, "SQUARES", {
  enumerable: true,
  get: function get() {
    return _squares.SQUARES;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function get() {
    return _constants.constants;
  }
});
exports.Inputs = void 0;

var _Address = _interopRequireDefault(require("./elements/atoms/Inputs/Address"));

var _FormAddress = _interopRequireDefault(require("./elements/atoms/Inputs/FormAddress"));

var _GlobalAddress = _interopRequireDefault(require("./elements/atoms/Inputs/GlobalAddress"));

var _Advantage = _interopRequireDefault(require("./elements/atoms/Advantage"));

var _AirportItem = _interopRequireDefault(require("./elements/atoms/AirportItem"));

var _BagSelector = _interopRequireDefault(require("./elements/atoms/BagSelector"));

var _BookingConfirmation = _interopRequireDefault(require("./elements/molecules/BookingConfirmation"));

var _Button = _interopRequireDefault(require("./elements/atoms/Button"));

var _DiscontinuousLine = _interopRequireDefault(require("./elements/atoms/DiscontinuousLine"));

var _Icon = _interopRequireDefault(require("./elements/atoms/Icon"));

var _Checkmark = _interopRequireDefault(require("./elements/atoms/Checkmark"));

var _ColorIcon = _interopRequireDefault(require("./elements/atoms/ColorIcon"));

var _Flight = _interopRequireDefault(require("./elements/atoms/Flight"));

var _FlightItemStops = _interopRequireDefault(require("./elements/atoms/FlightItemStops"));

var _FlightSummary = _interopRequireDefault(require("./elements/atoms/FlightSummary"));

var _Title = _interopRequireDefault(require("./elements/atoms/Title"));

var _SubTitle = _interopRequireDefault(require("./elements/atoms/SubTitle"));

var _Picture = _interopRequireDefault(require("./elements/atoms/Picture"));

var _Date = _interopRequireDefault(require("./elements/atoms/Inputs/Date"));

var _Text = _interopRequireDefault(require("./elements/atoms/Inputs/Text"));

var _Phone = _interopRequireDefault(require("./elements/atoms/Inputs/Phone"));

var _InputSelect = _interopRequireDefault(require("./elements/atoms/Inputs/InputSelect"));

var _Checkbox = _interopRequireDefault(require("./elements/atoms/Inputs/Checkbox"));

var _Link = _interopRequireDefault(require("./elements/atoms/Link"));

var _Legend = _interopRequireDefault(require("./elements/atoms/Legend"));

var _Loading = _interopRequireDefault(require("./elements/atoms/Loading"));

var _Map = _interopRequireDefault(require("./elements/atoms/Map"));

var _MobileCta = _interopRequireDefault(require("./elements/atoms/MobileCta"));

var _Notification = _interopRequireDefault(require("./elements/atoms/Notification"));

var _Header = _interopRequireDefault(require("./elements/molecules/Header"));

var _Promocode = _interopRequireDefault(require("./elements/atoms/Promocode"));

var _RadioButton = _interopRequireDefault(require("./elements/atoms/RadioButton"));

var _SlotDaySelector = _interopRequireDefault(require("./elements/atoms/SlotDaySelector"));

var _Terminal = _interopRequireDefault(require("./elements/atoms/Terminal"));

var _Footer = _interopRequireDefault(require("./elements/molecules/Footer"));

var _AltFooter = _interopRequireDefault(require("./elements/molecules/AltFooter"));

var _BobInfo = _interopRequireDefault(require("./elements/molecules/BobInfo"));

var _Popup = _interopRequireDefault(require("./elements/molecules/Popup"));

var _PriceBreakdown = _interopRequireDefault(require("./elements/atoms/PriceBreakdown"));

var _Tabs = _interopRequireDefault(require("./elements/atoms/Tabs"));

var _TimeSlots = _interopRequireDefault(require("./elements/molecules/TimeSlots"));

var _TravelWidget = _interopRequireDefault(require("./elements/molecules/TravelWidget"));

var _Spinner = _interopRequireDefault(require("./elements/atoms/Spinner"));

var _Select = _interopRequireDefault(require("./elements/atoms/Inputs/Select"));

var _ServiceStatus = _interopRequireDefault(require("./elements/molecules/ServiceStatus"));

var _Timeline = _interopRequireDefault(require("./elements/atoms/Timeline"));

var _index = _interopRequireDefault(require("./providers/Cookie/index"));

var _index2 = _interopRequireDefault(require("./providers/Date/index"));

var _index3 = _interopRequireDefault(require("./providers/Validate/index"));

var _helpers = require("./helpers");

var _widths = require("./styles/widths");

var _palette = require("./styles/palette");

var _normalize = require("./styles/normalize");

var _colorIcons = require("./static/icons/colorIcons");

var _icons = require("./static/icons/icons");

var _squares = require("./static/icons/squares");

var _constants = require("./static/constants");

var Inputs = {
  Address: _Address["default"],
  FormAddress: _FormAddress["default"],
  Date: _Date["default"],
  GlobalAddress: _GlobalAddress["default"],
  Text: _Text["default"],
  InputSelect: _InputSelect["default"],
  Checkbox: _Checkbox["default"],
  Select: _Select["default"],
  Phone: _Phone["default"]
};
exports.Inputs = Inputs;